export default {

	Hardware: {
	    FetchLocks: 'v3/api/centre/@centre_id@/locks',
		GetLock: 'v3/api/hardware/lock/@lock_id@',
		EnableTagRegisration: 'v3/api/hardware/lock/@lock_id@/tag_registration',
		GetLocksWithLowBattery: 'v3/api/hardware/locks/low_battery',
		GetIQNetworkDetails: 'v3/api/hardware/iq/@iq_id@/network_details',
	},

    Access: {
        FetchForBooking: 'v3/api/access/booking/@booking_id@',
        ToggleForBooking: 'v3/api/access/booking/@booking_id@',
        ToggleForBookingEmployees: 'v3/api/access/booking-employees/@booking_id@',
        FetchApprovalRequests: 'v3/api/centre/@centre_id@/access/approval-requests',
        GetApprovalRequest: 'v3/api/access/approval-requests/@request_id@',
        SearchApprovalRequests: 'v3/api/centre/@centre_id@/access/approval-requests/search',
        SearchContractorAccess: 'v3/api/centre/@centre_id@/access/contractor-access/search',
        AvailableTypes: 'v3/api/access/available-types',
        DeleteContractorAccess: 'v3/api/centre/@centre_id@/access/@access_group@',
        GetMaxCustomAccessDate: 'v3/api/centre/@centre_id@/company/@company_id@/get-max-custom-access-date'
    },

    RemoteAccess: {
        Store: 'v3/api/centre/access/remote/store',
        Unlock: 'v3/api/centre/access/remote/@remote_access_id@/@lock_id@/unlock',
        Error: 'v3/api/centre/access/remote/@remote_access_id@/@lock_id@/error',
        Unreached: 'v3/api/centre/access/remote/@remote_access_id@/@lock_id@/unreached',
        Finish: 'v3/api/centre/access/remote/@remote_access_id@/finish',
        GetActiveBookingReferences: 'v3/api/centre/@centre_id@/active_bookings/@user_id@',
        Locks: 'v3/api/centre/@centre_id@/remote/locks',
    },

	Events: {
		Fetch: 'v3/api/events/@type@',
		Export: 'v3/api/events/export/@type@',
		Types: 'v3/api/events/types/@type@',
        FetchExports: 'v3/api/events/exports/@requestedForType@/@requestedForId@',
        Download: 'v3/api/events/export/download/@exportId@',
    },

    Users: {
        SearchByName: 'v3/api/search/users/by_name',
        SearchByNameAndCompanyId: 'v3/api/search/users/by_name_and_company_id',
        SearchByNameOrCompanyName: 'v3/api/search/users/by_name_or_company_name',
        searchByField: 'v3/api/search/users/by_field',
        GetUserById: 'v3/api/search/users/by_id',
        GetUsersByIds: 'v3/api/search/users/by_ids',
    },

    Companies: {
	    Users: 'v3/api/company/@company_id@/users',
        User: 'v3/api/company/@company_id@/user/@user_id@',
        BookingInventories: 'v3/api/centre/@centre_id@/company/@company_id@/inventories',
        List: 'v3/api/centre/@centre_id@/companies',
    },

    Configurations: {
	    Global: 'v3/api/configuration/global',
        SetGlobal: 'v3/api/configuration/@configuration_id@/global',
        Centre: 'v3/api/configuration/centre/@centre_id@',
        SetCentre: 'v3/api/configuration/@configuration_id@/centre',
        ToggleRemoteAccess: 'v3/api/configuration/centre/@centre_id@/toggle-remote-access',
    },


    Sync: {

	    GetManualSyncStatus: 'v3/api/sync/manual/get_status/@sync_type@?centre_id=@centre_id@&company_id=@company_id@',
	    GetSyncStatus: 'v3/api/sync/manual/@centre_id@/status',
        GetLastManualSyncs: 'v3/api/sync/manual/@centre_id@/last',
	    RequestManualCentreSync: 'v3/api/sync/manual/@centre_id@/request/@sync_type@',
	    RequestManualCompanySync: 'v3/api/sync/manual/@centre_id@/@company_id@/request/@sync_type@',

    },

    Inventories: {
        List: 'v3/api/centre/@centre_id@/inventories',
    },

    InventoryGroups: {
        ListWithoutCoomsRoom: 'v3/api/centre/@centre_id@/inventory-groups-without-cooms-room',
    },

    AccessGroupRemoval: {
        List: 'v3/api/tools/access-group-removals',
    }
}
